import styled from '@mui/material/styles/styled';

export const StyledImg = styled('img')`
	object-fit: cover;
	position: absolute;
	inset: 0px;
	width: 100%;
	height: 100%;
	z-index: -1;
`;
